import type { App } from 'vue';
import vRipple from '@/directives/VRipple';
import vTooltip from '@/directives/VTooltip';

export const loadDirectives = (app: App) => {
    app.directive('ripple', vRipple);
    app.directive('tooltip', vTooltip);
};
